// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_request/get_purchase_request.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseRequest } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseRequestRequest
 */
export class GetPurchaseRequestRequest extends Message<GetPurchaseRequestRequest> {
  /**
   * Unique identifier for the purchase request to retrieve
   *
   * @generated from field: string purchase_request_id = 1;
   */
  purchaseRequestId = "";

  constructor(data?: PartialMessage<GetPurchaseRequestRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseRequestRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseRequestRequest {
    return new GetPurchaseRequestRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseRequestRequest {
    return new GetPurchaseRequestRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseRequestRequest {
    return new GetPurchaseRequestRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseRequestRequest | PlainMessage<GetPurchaseRequestRequest> | undefined, b: GetPurchaseRequestRequest | PlainMessage<GetPurchaseRequestRequest> | undefined): boolean {
    return proto3.util.equals(GetPurchaseRequestRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseRequestResponse
 */
export class GetPurchaseRequestResponse extends Message<GetPurchaseRequestResponse> {
  /**
   * List of purchase requests matching the criteria
   *
   * @generated from field: com.neulink.pharmacy.PurchaseRequest purchase_request = 1;
   */
  purchaseRequest?: PurchaseRequest;

  /**
   * ID of the next purchase request for pagination
   *
   * @generated from field: string next_purchase_request_id = 2;
   */
  nextPurchaseRequestId = "";

  /**
   * ID of the previous purchase request for pagination
   *
   * @generated from field: string previous_purchase_request_id = 3;
   */
  previousPurchaseRequestId = "";

  /**
   * Total number of purchase requests matching the criteria
   *
   * @generated from field: int32 total_count = 4;
   */
  totalCount = 0;

  /**
   * Current index of the purchase request in the list
   *
   * @generated from field: int32 current_index = 5;
   */
  currentIndex = 0;

  constructor(data?: PartialMessage<GetPurchaseRequestResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseRequestResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_request", kind: "message", T: PurchaseRequest },
    { no: 2, name: "next_purchase_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "previous_purchase_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "current_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseRequestResponse {
    return new GetPurchaseRequestResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseRequestResponse {
    return new GetPurchaseRequestResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseRequestResponse {
    return new GetPurchaseRequestResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseRequestResponse | PlainMessage<GetPurchaseRequestResponse> | undefined, b: GetPurchaseRequestResponse | PlainMessage<GetPurchaseRequestResponse> | undefined): boolean {
    return proto3.util.equals(GetPurchaseRequestResponse, a, b);
  }
}

